import styled from "styled-components";

export const Wrapper = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  ...theme.paddings(24),
  position: "sticky",
  gap: 10,
  width: 350,
  backgroundColor: theme.palette.white,
  boxShadow: `0 1px 5px ${theme.palette.shadowMd}`,
  borderRadius: "8px",

  [theme.down("xl")]: {
    width: 300,
  },

  [theme.down("lg")]: {
    width: "100%",
  },
}));

export const Header = styled("div")(({ theme }) => ({
  padding: "20px 10px",
  borderBottom: `1px solid ${theme.palette.borderLight}`,
}));

export const Title = styled("h4")(({ theme }) => ({
  fontSize: "16px",
  fontWeight: "600",
  color: theme.palette.textPrimary,
}));

export const PriceItem = styled("div")(({ theme, $isSmallText }) => ({
  ...theme.mixins.flexCenterBetween,
  fontSize: $isSmallText ? 14 : 18,
  color: theme.palette.textSecondary,

  "& > span.commission": {
    color: "#dc2626",
  },

  "& > .price__footer": {
    fontSize: "15px",
    fontWeight: "600",
    color: theme.palette.textPrimary,
  },

  "& > .total__amount": {
    fontSize: "24px",
    fontWeight: "700",
    color: theme.palette.primaryLight,
    letterSpacing: "-0.5px",
  },

  [theme.down("md")]: {
    "& > .total__amount": {
      fontSize: "22px",
    },
  },

  [theme.down("sm")]: {
    fontSize: $isSmallText ? 12 : 15,

    "& > .price__footer": {
      fontSize: "14px",
    },

    "& > .total__amount": {
      fontSize: "18px",
    },
  },

  [theme.down("xs")]: {
    fontSize: $isSmallText ? 11 : 13,

    "& > .price__footer": {
      fontSize: "13px",
    },

    "& > .total__amount": {
      fontSize: "16px",
    },
  },
}));

export const LineDivider = styled("div")(({ theme }) => ({
  width: "100%",
  height: 1,
  backgroundColor: theme.palette.borderDefault,
}));
